const data = {
  url: "https://stranger-backend-service.onrender.com",
};
export default data;
